import { db } from '../firebase';
import {
  collection,
  getDocs,
} from 'firebase/firestore';

const normalizeTournament = (docSnap) => {
  const data = docSnap.data();

  return {
    id: Number(data.id ?? docSnap.id),
    name: data.name || '',
    players: Number(data.players || 8),
    location: data.location || '',
    date: data.date || '',
    time: data.time || '',
    picture: data.picture || '',
    price: Number(data.price || 0),
    eloMin: data.eloMin ?? null,
    eloMax: data.eloMax ?? null,
    territory: data.territory === 'flanders' ? 'flanders' : 'wallonia',
    region: data.region || '',
    visible: data.visible ?? true,
    archived: data.archived ?? false,
    ...(data.badge ? { badge: data.badge } : {}),
    ...(data.badgef ? { badgef: data.badgef } : {}),
  };
};

const sortTournaments = (tournaments) => {
  return [...tournaments].sort((a, b) => Number(a.id) - Number(b.id));
};

export const fetchTournaments = async () => {
  const snapshot = await getDocs(collection(db, 'tournament_catalog'));

  const tournaments = snapshot.docs.map(normalizeTournament);

  console.log('🔥 TOURNOIS FIRESTORE:', tournaments);

  return sortTournaments(tournaments);
};

export default fetchTournaments;
